<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2020/06/25
    // Modificado por: Wuilmer Garcia
    // Fecha de ultima Modificacion:  2020/06/25  
    // Causa: Creacion del componente

    Historial de Modificaciones
    // Fecha Modificación: 2020/06/24 
    // Modificación: Creación del componente

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario del Colegio -->

        <v-form ref="formDatos" lazy-validation>
            <v-dialog v-model="estadoModal" persistent scrollable max-width="75%">
                <v-card>

                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0"> 
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title> 

                    <v-divider></v-divider>


                    <v-card-text>

                        <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
                        <v-col class="d-flex flex-row-reverse pt-0">
                            <v-btn class="btn_block_style2" dark  @click="addItem()">Crear Plantilla</v-btn>
                        </v-col>
                    </v-row>

                    <v-col class="d-flex justify-end pt-0">
                        <v-col class="pt-0" cols="4">
                            <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line hide-details ></v-text-field>
                        </v-col>
                    </v-col>
                       
                       <v-data-table :headers="headers" :items="data" :search="search" :sort-by="['nombre_template']" :sort-desc="[false]" class="elevation-1 black--text" fixed-header>
 
            
                         <template v-slot:[`item.action_fec_us_ing`] ="{ item }">
                            {{item.fec_us_ing | filtroFecha}}
                        </template>

                         <template v-slot:[`item.action_fec_us_mod`] ="{ item }">
                             {{item.fec_us_mod | filtroFecha}}
                        </template>

                        <template v-slot:[`item.estado_template`] ="{ item }">
                            <v-chip v-if="item.estado_template===1" small class="color_activo">
                                Activo
                            </v-chip>

                            <v-chip v-if="item.estado_template===0" small class="color_inactivo">
                                Inactivo
                            </v-chip>
                        </template>

                        <template v-slot:[`item.action_editar`] ="{ item }">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-if="componenteEvento.editar_submodulo" v-on="on" class="btn_editar px-0 mx-0" fab x-small @click="editItem(item)">
                                        <v-icon>fa-pencil-alt</v-icon>
                                    </v-btn>
                                </template>
                                <span>EDITAR PLANTILLA</span>
                            </v-tooltip>
                        </template>


                        <template v-slot:[`item.action_borrar`] ="{ item }">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-if="componenteEvento.borrar_submodulo" v-on="on" class="btn_eliminar px-0 mx-0" fab x-small @click="deleteUsuario(item.id)">
                                        <v-icon>fa-trash-alt</v-icon>
                                    </v-btn>
                                </template>
                                <span>BORRAR PLANTILLA</span>
                            </v-tooltip>
                        </template>
                        
                       </v-data-table>
                    </v-card-text>


                </v-card>
            </v-dialog>
        </v-form>

        <!-- fin modal del Colegio -->

        <component :is="compName" :estadoModal="estadoModalConfig" :parametros="parametroConfig" 
                    @close="closeModal">
        </component>

    </div>
</template>

<script>



    import axios from "../../../../helpers/axios";
    import {mapMutations, mapGetters, mapActions} from 'vuex';

    import TemplateFormComp from './components/TemplateFormComp'
    export default {
        name:'templateGestor',
        
        props:['estadoModal' ,'parametros', 'evento'],
        
        components:{
            TemplateFormComp
        }, 
        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':1, "id_modulo": 4}, //sud_modulo y modulo
            datoLogin: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////

            //// CONSULTA PRINCIPAL
            // evento: 'agregar',
            search: '',
            data: [],

            headers: [
                /* { text: 'INDEX', align: 'left', value: 'index', class:'secondary'},
                { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
                // { text: 'ID', value: 'id' , class:'secondary black--text'},
                { text: 'Nonbre de la  Plantilla', value: 'nombre_template' , class:'secondary black--text'},
                { text: 'Fecha creacion', value: 'action_fec_us_ing' , class:'secondary black--text'},
                {text: 'Fecha de Edicción', value: 'action_fec_us_mod' , class:'secondary black--text'},
                { text: 'ESTADO', value: 'estado_template', align: 'center', class:'secondary black--text'},
                { text: 'EDITAR', value: 'action_editar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'},
                // { text: 'BORRAR', value: 'action_borrar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'}

            ],

            formTitle: 'Visualizar plantilla del gestor de contenido',

            // componente Fomulario Colegio

            compName: null,
            estadoModalConfig: true,
            parametroConfig : [],
        

        }),


        //computadas
        computed: {
            ...mapGetters('login', [ 'componenteEvento']),
       

        },


        mounted() {
            this.loadMain()
        },


        created(){
            this.actualizarParamentro()
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
            // -- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),
            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },


            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


             //  ------- input tipo fecha  --------
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            //-- cargar Parametros de inicio del componente --
            async loadMain(){
                this.getTemplate()
            },


            //-------mostrar registros------------
            async getTemplate(){
            
                try{
                    let response   = await axios.post(`/manager/contenido/getTemplate/`,{filtro:{tipo:1}})
                    this.data = response.data
                
                }catch(error){
                    console.log(error)
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }        

            },


            ///////////////////////////////////////////////////
            //-- Componente de  Configuracion de colegio  -----
            ///////////////////////////////////////////////////

            addItem(){
               //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
                this.parametroConfig = {evento:"agregar"}
                this.compName = "TemplateFormComp"
                this.estadoModalConfig = true
            },

            editItem (item) {
                this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
                this.parametroConfig = {evento:"editar", item} 
                this.compName = "TemplateFormComp"
                this.estadoModalConfig = true
            },


            /*******cerrar modal y blanquear arreglos */
            closeModal(){

                this.estadoModalConfig=false
                this.loadMain()

            },

        },

    }
</script>

<style scoped>
</style>